import React from 'react'

import { Form } from 'react-final-form'
import { TextField } from 'mui-rff'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

interface Value {
    name: string
}

export interface Props {
    initialValue?: string
    onClose: () => void
    onSubmit: (value: Value) => void
}

export const DashboardNameDialog: React.FC<Props> = ({ initialValue, onClose, onSubmit }: Props) => {
    const initialValues = initialValue ? { name: initialValue } : undefined

    return (
        <Form<Value>
            initialValues={initialValues}
            onSubmit={onSubmit}
            render={({ handleSubmit, pristine }): React.ReactNode => (
                <Dialog open onClose={onClose}>
                    <DialogTitle>Enter New Dashboard Name</DialogTitle>
                    <DialogContent>
                        <TextField
                            variant="standard"
                            autoFocus
                            fullWidth
                            required
                            id="name"
                            label="Dashboard Name"
                            name="name"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleSubmit} color="primary" disabled={pristine}>
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        />
    )
}
